import { AutocompleteSuggestion } from '../models/Autocomplete';

const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
const GET_SUGGESTIONS = 'GET_SUGGESTIONS';
export const SORT_SUGGESTIONS = 'SORT_SUGGESTIONS';
export const AUTOCOMPLETE_NAMESPACE = 'AUTOCOMPLETE';
export const AUTOCOMPLETE_SET_SUGGESTIONS = `${AUTOCOMPLETE_NAMESPACE}/${SET_SUGGESTIONS}`;
export const AUTOCOMPLETE_GET_SUGGESTIONS = `${AUTOCOMPLETE_NAMESPACE}/${GET_SUGGESTIONS}`;

export interface IAutocompleteState {
  suggestions: AutocompleteSuggestion[];
}

const autocompleteState: IAutocompleteState = {
    suggestions: [],
};

const mutations = {
    [SET_SUGGESTIONS](state: IAutocompleteState, suggestions: AutocompleteSuggestion[]) {
        state.suggestions = suggestions;
    },
};

const getters = {
    [GET_SUGGESTIONS](state: IAutocompleteState) {
        return state.suggestions;
    },
};

const actions = {

};

export const autocompleteStore = {
    state: autocompleteState,
    actions,
    mutations,
    getters,
};